import { Pin } from "lucide-react";
import ContentEditor from "@/components/ContentEditor";

export default function AdminForumRules() {
  return (
    <ContentEditor
      contentKey="forum_rules"
      pageHeading="Topluluk kurallarını düzenle"
      description="Tartışmalar sayfasının en üstünde sabit gönderi olarak görünür."
      icon={Pin}
      redirectPath="/forum"
      successMessage="Topluluk kuralları güncellendi"
    />
  );
}
